import { Component, OnInit } from '@angular/core';
import { DashboarddemoService } from '../Dashboad1.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-learn-next1',
  templateUrl: './learn-next.component.html',
  styleUrls: ['./learn-next.component.css']
})
export class LearnNextdemoComponent implements OnInit {
   model = {
    "userId":localStorage.getItem('userId'),
    "employeeId": 0,
    "pageNo": 1,
    "pageSize": 4,
    "year": 2023,
    "quarterNo": 2,
    "searchText": "",
    "departments": 5
  }

  data: any;

  constructor(private service:DashboarddemoService) { }

  ngOnInit() {
    
    this.model.employeeId = parseInt(localStorage.getItem('Id'));
    this.getRecommendedProgramsOfEmployee(this.model)

  }
  getRecommendedProgramsOfEmployee(data:any){
    this.service.getRecommendedProgramsOfEmployee(data).subscribe(x => {
      this.data = x;
    })

  }
  navigatetoESD(){
    window.open(environment.esdMyLearningUrl+'/programs');
  }



}
